<script>
import { api } from '@/api'
import { currency, date } from '@/filters'
import { mapGetters } from 'vuex'
import { getLocaleLink } from '@/util/localization'
import * as modes from '@/constants/modes'

export default {
  modes,
  data() {
    return {
      /**
       * @type {{
       *  localTime: string
       *  price: {
       *    valueGross: number
       *    currency: string
       *  }
       * }}
       */
      appRunData: undefined
    }
  },
  computed: {
    ...mapGetters([
      'locale',
      'mode'
    ]),
    getAppRunPrice() {
      const valueGross = this.appRunData?.price?.valueGross
      return valueGross ? currency(valueGross, this.locale, {
        currency: this.appRunData?.price?.currency || 'EUR'
      }) : undefined
    },
    getAppRunTime() {
      const localTime = this.appRunData?.localTime
      if (!localTime) {
        return undefined
      }
      const formattedDate = this.formatTime(localTime)
      return `${formattedDate} UTC`
    },
    getAppRunDate() {
      const localTime = this.appRunData?.localTime
      return date(localTime, this.locale)
    },
    takePartLink() {
      const isPreRace = [this.$options.modes.PRE].includes(this.mode)
      if (isPreRace) {
        return this.getLocaleLink('/locations?eventType=app')
      }
      return this.getLocaleLink('/registration/app/register')
    }
  },
  async beforeMount() {
    this.appRunData = await this.fetchAppRunData()
  },
  methods: {
    getLocaleLink,
    async fetchAppRunData() {
      const { data } = await api.get('events/app')
      return data
    },
    /**
     * format time in format hh:mm
     * @param time {string}
     */
    formatTime(time) {
      const timeDate = new Date(time)
      return new Intl.DateTimeFormat(this.locale, ({
        hour: 'numeric',
        minute: 'numeric',
        timeZone: 'UTC'
      })).format(timeDate)
    }
  }
}
</script>

<template>
  <div
    class="d-flex flex-column shadow rounded-bottom"
  >
    <section class="image-section position-relative punch-bottom">
      <div class="badge p-1 text-primary">
        <icon name="AppLocation"/>
        <span
          class="font-weight-bold"
          v-text="$t('events.eventType.app')"
        />
      </div>
      <img
        src="@/assets/images/runners.jpeg"
        alt="register for the app run"
        class="rounded-top"
      >
    </section>
    <section class="card-content p-3 punch-top bg-white rounded-bottom">
      <section class="mb-2">
        <span
          class="text-uppercase font-xl font-weight-bold text-condensed"
          v-text="$t('events.eventType.app')"
        />
        <div
          class="d-flex align-items-baseline font-sm subtle-dark font-weight-bold"
          style="gap:0.4rem;"
        >
          <span v-text="getAppRunDate"/>
          <span v-text="getAppRunTime"/>
        </div>
      </section>
      <section
        style="line-height: 1.5rem;"
        class="d-flex align-items-center justify-content-between"
      >
        <div class="d-flex flex-column align-items-start">
          <span
            class="text-secondary text-right font-lg font-weight-bold"
            v-text="getAppRunPrice"
          />
          <span
            class="subtle font-sm"
            v-text="$t('events.taxIncluded')"
          />
        </div>
        <a
          v-track-click="'Register Now Teaser'"
          :href="takePartLink"
          class="btn btn-secondary"
          target="_blank"
        >
          {{ $t('button.takePart') }}
        </a>
      </section>
    </section>
  </div>
</template>

<style scoped lang="scss">
@import "~@/scss/bootstrap/custom";

.image-section {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.subtle {
  color: $text-light-subtle;
}

.subtle-dark {
  color: $text-dark-subtle
}

.card-content {
  display: flex;
  flex-direction: column;;
  width: 100%;
  padding: 1rem;
  justify-content: center;
}

.badge {
  background-color: $yellow;
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
}

.punch-top {
  margin-top: 1px;
  -webkit-mask-box-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='36' height='36'%3E%3Cpath d='M 0 12 A 12 12 0 0 0 12 0 L 24 0 A 12 12 0 0 0 36 12 L 36 24 A 12 12 0 0 0 24 36 L 12 36 A 12 12 0 0 0 0 24 Z' fill='%23000'/%3E%3C/svg%3E") 12 stretch;
  -webkit-mask-box-image-width: 24px 24px 0 24px;
}

.punch-bottom {
  -webkit-mask-box-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='36' height='36'%3E%3Cpath d='M 0 12 A 12 12 0 0 0 12 0 L 24 0 A 12 12 0 0 0 36 12 L 36 24 A 12 12 0 0 0 24 36 L 12 36 A 12 12 0 0 0 0 24 Z' fill='%23000'/%3E%3C/svg%3E") 12 stretch;
  -webkit-mask-box-image-width: 0 24px 24px 24px;
}
</style>
